
import request from '@/utils/request'
export function selectonline () {
  return request({
    url: '/online/selectonline',
    method: 'get'
  })
}
